import { ApiType } from "@gymflow/common";
import { PaymentMethodDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useQueryPaymentMethod(
  {
    api,
    memberId,
    paymentMethodId,
  }: {
    api: ApiType;
    memberId: string;
    paymentMethodId: string;
  },
  queryOpts?: Omit<UseQueryOptions<PaymentMethodDTO>, "queryKey">,
) {
  return useQuery({
    queryKey: memberQueryKeys.paymentMethod(memberId, paymentMethodId),
    queryFn: async () => {
      return (await api.memberApi.getPaymentMethod(memberId, paymentMethodId))
        .data;
    },
    ...queryOpts,
  });
}
